
// Mock data for development
export interface Promo {
  id: string;
  name: string;
  description: string;
  image: string;
  provinces: Province[];
}

export interface Province {
  id: string;
  name: string;
  locations?: Location[];
}

export interface Location {
  id: string;
  city: string;
  supermarket: string;
  address: string;
  products: Product[];
}

export interface Product {
  id: string;
  name: string;
  ean: string;
  price: string;
}

export const mockPromos: Promo[] = [
  {
    id: "gliss",
    name: "Gliss",
    description: "Promozione sui prodotti per capelli Gliss. Acquista due prodotti e ricevi uno sconto del 50% sul secondo.",
    image: "https://via.placeholder.com/150?text=Gliss",
    provinces: [
      {
        id: "MI",
        name: "Milano",
        locations: [
          {
            id: "loc_gliss1",
            city: "Milano",
            supermarket: "Esselunga",
            address: "Via Torino 45",
            products: [
              {
                id: "p_gliss1",
                name: "Gliss Shampoo",
                ean: "8001234567800",
                price: "3.99€",
              },
              {
                id: "p_gliss2",
                name: "Gliss Balsamo",
                ean: "8001234567801",
                price: "4.50€",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "1",
    name: "Cashback Ace",
    description: "Rimborso di 5€ per l'acquisto di prodotti Ace. Acquista almeno 15€ di prodotti e ricevi un rimborso sulla tua carta.",
    image: "https://via.placeholder.com/150?text=Ace+Cashback",
    provinces: [
      {
        id: "MI",
        name: "Milano",
        locations: [
          {
            id: "loc1",
            city: "Milano",
            supermarket: "Carrefour",
            address: "Via Roma 123",
            products: [
              {
                id: "p1",
                name: "Ace Candeggina",
                ean: "8001234567890",
                price: "4.50€",
              },
              {
                id: "p2",
                name: "Ace Detersivo",
                ean: "8001234567891",
                price: "5.99€",
              },
            ],
          },
        ],
      },
      {
        id: "RM",
        name: "Roma",
        locations: [],
      },
      {
        id: "NA",
        name: "Napoli",
        locations: [
          {
            id: "loc2",
            city: "Napoli",
            supermarket: "Conad",
            address: "Via Napoli 45",
            products: [
              {
                id: "p3",
                name: "Ace Spray",
                ean: "8001234567892",
                price: "3.99€",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "2",
    name: "Concorso Dash",
    description: "Vinci un anno di bucato gratis con Dash. Acquista 2 confezioni e scopri se hai vinto!",
    image: "https://via.placeholder.com/150?text=Dash+Contest",
    provinces: [
      {
        id: "TO",
        name: "Torino",
        locations: [
          {
            id: "loc3",
            city: "Torino",
            supermarket: "Esselunga",
            address: "Via Torino 78",
            products: [
              {
                id: "p4",
                name: "Dash Pods",
                ean: "8001234567893",
                price: "8.99€",
              },
            ],
          },
        ],
      },
      {
        id: "FI",
        name: "Firenze",
        locations: [],
      },
    ],
  },
  {
    id: "3",
    name: "Concorso Nutella",
    description: "Vinci ogni giorno fantastici premi con Nutella. Acquista un vasetto e scopri il codice all'interno.",
    image: "https://via.placeholder.com/150?text=Nutella",
    provinces: [
      {
        id: "MI",
        name: "Milano",
        locations: [],
      },
      {
        id: "RM",
        name: "Roma",
        locations: [],
      },
      {
        id: "NA",
        name: "Napoli",
        locations: [],
      },
    ],
  },
];

// Function to search promos by name
export const searchPromos = (searchTerm: string): Promo[] => {
  if (!searchTerm || searchTerm.length < 3) {
    return [];
  }
  
  const normalizedTerm = searchTerm.toLowerCase();
  return mockPromos.filter(promo => 
    promo.name.toLowerCase().includes(normalizedTerm) ||
    promo.description.toLowerCase().includes(normalizedTerm)
  );
};

// List of all Italian provinces for the UI
export const italianProvinces: Province[] = [
  { id: "AG", name: "Agrigento" },
  { id: "AL", name: "Alessandria" },
  { id: "AN", name: "Ancona" },
  { id: "AO", name: "Aosta" },
  { id: "AR", name: "Arezzo" },
  { id: "AP", name: "Ascoli Piceno" },
  { id: "AT", name: "Asti" },
  { id: "AV", name: "Avellino" },
  { id: "BA", name: "Bari" },
  { id: "BT", name: "Barletta-Andria-Trani" },
  { id: "BL", name: "Belluno" },
  { id: "BN", name: "Benevento" },
  { id: "BG", name: "Bergamo" },
  { id: "BI", name: "Biella" },
  { id: "BO", name: "Bologna" },
  { id: "BZ", name: "Bolzano" },
  { id: "BS", name: "Brescia" },
  { id: "BR", name: "Brindisi" },
  { id: "CA", name: "Cagliari" },
  { id: "CL", name: "Caltanissetta" },
  { id: "CB", name: "Campobasso" },
  { id: "CE", name: "Caserta" },
  { id: "CT", name: "Catania" },
  { id: "CZ", name: "Catanzaro" },
  { id: "CH", name: "Chieti" },
  { id: "CO", name: "Como" },
  { id: "CS", name: "Cosenza" },
  { id: "CR", name: "Cremona" },
  { id: "KR", name: "Crotone" },
  { id: "CN", name: "Cuneo" },
  { id: "EN", name: "Enna" },
  { id: "FM", name: "Fermo" },
  { id: "FE", name: "Ferrara" },
  { id: "FI", name: "Firenze" },
  { id: "FG", name: "Foggia" },
  { id: "FC", name: "Forlì-Cesena" },
  { id: "FR", name: "Frosinone" },
  { id: "GE", name: "Genova" },
  { id: "GO", name: "Gorizia" },
  { id: "GR", name: "Grosseto" },
  { id: "IM", name: "Imperia" },
  { id: "IS", name: "Isernia" },
  { id: "SP", name: "La Spezia" },
  { id: "AQ", name: "L'Aquila" },
  { id: "LT", name: "Latina" },
  { id: "LE", name: "Lecce" },
  { id: "LC", name: "Lecco" },
  { id: "LI", name: "Livorno" },
  { id: "LO", name: "Lodi" },
  { id: "LU", name: "Lucca" },
  { id: "MC", name: "Macerata" },
  { id: "MN", name: "Mantova" },
  { id: "MS", name: "Massa-Carrara" },
  { id: "MT", name: "Matera" },
  { id: "ME", name: "Messina" },
  { id: "MI", name: "Milano" },
  { id: "MO", name: "Modena" },
  { id: "MB", name: "Monza e Brianza" },
  { id: "NA", name: "Napoli" },
  { id: "NO", name: "Novara" },
  { id: "NU", name: "Nuoro" },
  { id: "OR", name: "Oristano" },
  { id: "PD", name: "Padova" },
  { id: "PA", name: "Palermo" },
  { id: "PR", name: "Parma" },
  { id: "PV", name: "Pavia" },
  { id: "PG", name: "Perugia" },
  { id: "PU", name: "Pesaro e Urbino" },
  { id: "PE", name: "Pescara" },
  { id: "PC", name: "Piacenza" },
  { id: "PI", name: "Pisa" },
  { id: "PT", name: "Pistoia" },
  { id: "PN", name: "Pordenone" },
  { id: "PZ", name: "Potenza" },
  { id: "PO", name: "Prato" },
  { id: "RG", name: "Ragusa" },
  { id: "RA", name: "Ravenna" },
  { id: "RC", name: "Reggio Calabria" },
  { id: "RE", name: "Reggio Emilia" },
  { id: "RI", name: "Rieti" },
  { id: "RN", name: "Rimini" },
  { id: "RM", name: "Roma" },
  { id: "RO", name: "Rovigo" },
  { id: "SA", name: "Salerno" },
  { id: "SS", name: "Sassari" },
  { id: "SV", name: "Savona" },
  { id: "SI", name: "Siena" },
  { id: "SR", name: "Siracusa" },
  { id: "SO", name: "Sondrio" },
  { id: "SU", name: "Sud Sardegna" },
  { id: "TA", name: "Taranto" },
  { id: "TE", name: "Teramo" },
  { id: "TR", name: "Terni" },
  { id: "TO", name: "Torino" },
  { id: "TP", name: "Trapani" },
  { id: "TN", name: "Trento" },
  { id: "TV", name: "Treviso" },
  { id: "TS", name: "Trieste" },
  { id: "UD", name: "Udine" },
  { id: "VA", name: "Varese" },
  { id: "VE", name: "Venezia" },
  { id: "VB", name: "Verbano-Cusio-Ossola" },
  { id: "VC", name: "Vercelli" },
  { id: "VR", name: "Verona" },
  { id: "VV", name: "Vibo Valentia" },
  { id: "VI", name: "Vicenza" },
  { id: "VT", name: "Viterbo" },
  { id: "SM", name: "San Marino" },
  { id: "CV", name: "Vaticano" },
];

// Limiti massimi di inserimenti per provincia
export const provinceLimits: Record<string, number> = {
  "AG": 10, // Agrigento
  "AL": 5,  // Alessandria
  "AN": 5,  // Ancona
  "AO": 5,  // Aosta
  "AR": 5,  // Arezzo
  "AP": 3,  // Ascoli Piceno
  "AT": 3,  // Asti
  "AV": 5,  // Avellino
  "BA": 15, // Bari
  "BT": 5,  // Barletta-Andria-Trani
  "BL": 3,  // Belluno
  "BN": 3,  // Benevento
  "BG": 10, // Bergamo
  "BI": 3,  // Biella
  "BO": 10, // Bologna
  "BZ": 5,  // Bolzano
  "BS": 10, // Brescia
  "BR": 5,  // Brindisi
  "CA": 10, // Cagliari
  "CL": 3,  // Caltanissetta
  "CB": 3,  // Campobasso
  "CE": 8,  // Caserta
  "CT": 10, // Catania
  "CZ": 5,  // Catanzaro
  "CH": 3,  // Chieti
  "CO": 5,  // Como
  "CS": 5,  // Cosenza
  "CR": 3,  // Cremona
  "KR": 3,  // Crotone
  "CN": 5,  // Cuneo
  "EN": 3,  // Enna
  "FM": 3,  // Fermo
  "FE": 3,  // Ferrara
  "FI": 10, // Firenze
  "FG": 5,  // Foggia
  "FC": 5,  // Forlì-Cesena
  "FR": 5,  // Frosinone
  "GE": 10, // Genova
  "GO": 3,  // Gorizia
  "GR": 3,  // Grosseto
  "IM": 3,  // Imperia
  "IS": 3,  // Isernia
  "SP": 3,  // La Spezia
  "AQ": 3,  // L'Aquila
  "LT": 5,  // Latina
  "LE": 5,  // Lecce
  "LC": 3,  // Lecco
  "LI": 3,  // Livorno
  "LO": 3,  // Lodi
  "LU": 3,  // Lucca
  "MC": 3,  // Macerata
  "MN": 3,  // Mantova
  "MS": 3,  // Massa-Carrara
  "MT": 3,  // Matera
  "ME": 5,  // Messina
  "MI": 25, // Milano
  "MO": 5,  // Modena
  "MB": 8,  // Monza e Brianza
  "NA": 15, // Napoli
  "NO": 3,  // Novara
  "NU": 3,  // Nuoro
  "OR": 3,  // Oristano
  "PD": 8,  // Padova
  "PA": 10, // Palermo
  "PR": 5,  // Parma
  "PV": 8,  // Pavia
  "PG": 5,  // Perugia
  "PU": 3,  // Pesaro e Urbino
  "PE": 3,  // Pescara
  "PC": 3,  // Piacenza
  "PI": 5,  // Pisa
  "PT": 3,  // Pistoia
  "PN": 3,  // Pordenone
  "PZ": 3,  // Potenza
  "PO": 3,  // Prato
  "RG": 3,  // Ragusa
  "RA": 3,  // Ravenna
  "RC": 5,  // Reggio Calabria
  "RE": 5,  // Reggio Emilia
  "RI": 3,  // Rieti
  "RN": 5,  // Rimini
  "RM": 20, // Roma
  "RO": 3,  // Rovigo
  "SA": 10, // Salerno
  "SS": 5,  // Sassari
  "SV": 3,  // Savona
  "SI": 3,  // Siena
  "SR": 3,  // Siracusa
  "SO": 3,  // Sondrio
  "SU": 3,  // Sud Sardegna
  "TA": 5,  // Taranto
  "TE": 3,  // Teramo
  "TR": 3,  // Terni
  "TO": 15, // Torino
  "TP": 3,  // Trapani
  "TN": 5,  // Trento
  "TV": 5,  // Treviso
  "TS": 3,  // Trieste
  "UD": 3,  // Udine
  "VA": 8,  // Varese
  "VE": 8,  // Venezia
  "VB": 3,  // Verbano-Cusio-Ossola
  "VC": 3,  // Vercelli
  "VR": 8,  // Verona
  "VV": 3,  // Vibo Valentia
  "VI": 5,  // Vicenza
  "VT": 3,  // Viterbo
  "SM": 1,  // San Marino
  "CV": 1,  // Vaticano
};
